import React, {useState} from "react";
import {Sidebar, Menu, MenuItem, SubMenu, menuClasses} from "react-pro-sidebar";

import IconButton from "@mui/material/IconButton";

import MenuOpenOutlinedIcon from "@mui/icons-material/MenuOpenOutlined";
import NotificationImportantOutlinedIcon from "@mui/icons-material/NotificationImportantOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {sideBarNavStyles} from "./sideBarNavStyles";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import RecentActorsIcon from "@mui/icons-material/RecentActors";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ScheduleIcon from "@mui/icons-material/Schedule";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import ChecklistIcon from "@mui/icons-material/Checklist";
import OtherHousesOutlinedIcon from "@mui/icons-material/OtherHousesOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import ConstructionOutlinedIcon from "@mui/icons-material/ConstructionOutlined";
import HomeRepairServiceOutlinedIcon from "@mui/icons-material/HomeRepairServiceOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import FitScreenOutlinedIcon from "@mui/icons-material/FitScreenOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import {CPSConstants, PageNames} from "commonUtils/enumerations";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import Box from "@mui/material/Box";
import {encrypt} from "commonUtils/crypto";
import FacultyBasicSearch from "features/Faculty/components/FacultyBasicSearch";
import {OLD_CPS_URL} from "commonUtils/globalAPISettings";
import {store, useAppDispatch} from "../../redux/store";
import {updateFacultyId} from "../../redux/reducers/authSlice";
import {Loader} from "components/FormComponents/Loader/Loader";
import {isValidObject, loggedMessage} from "commonUtils/utils";

interface pages {
  displayMode: number;
  displayOrder: number;
  displayText: string;
  id: number;
  isNew: boolean;
  pageToLoad: string;
  parentMenuItemId: number;
}
interface subPages {
  displayMode: number;
  displayOrder: number;
  displayText: string;
  id: number;
  isNew: boolean;
  pages: pages[];
  pageToLoad: string;
  parentMenuItemId: number;
}

export const SidebarNav: React.FC<{subPages: subPages[]}> = ({subPages}) => {
  const location = useLocation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  const BRANDS_SUBBRANDS_ID = 46;

  const pathName = location.pathname;
  const SelectedTopMenu = pathName.slice(1, pathName.length) + location.search;
  const regex = /[^/]+/;
  const match = SelectedTopMenu.match(regex);
  const [toggled, setToggled] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [loader, setLoader] = React.useState(false);
  const [selectedPage, setSelectedPage] = React.useState(0);
  const [menuIndex, setMenuIndex] = React.useState(0);

  if (isValidObject(location?.state?.params)) {
    searchParams = new URLSearchParams(location?.state?.params);
  }
  const submenuid = Number(
    searchParams.get("submenuid") ??
      searchParams.get("subMenuid") ??
      searchParams.get("subMenuId"),
  );

  React.useEffect(() => {
    const refreshList = [];
    let urlParams = window.location.search;
    let urlPathname = window?.location?.pathname?.split("/");
    // TO DO : have to remove this "===
    // activity once the activity page converted to new application
    if (
      !(urlParams?.length > 0) &&
      !(
        urlPathname[1] === "activity" ||
        urlPathname[1] === "alerts" ||
        urlPathname[1] === "administration"
      ) &&
      !(urlPathname[2] === "requestform")
    ) {
      try {
        let parentMenuItemId = 0;
        for (let index = 0; index < subPages.length; index++) {
          const element = subPages[index];
          parentMenuItemId = element.parentMenuItemId;
          if (element.pageToLoad) {
            refreshList.push({
              pathName: element.displayText,
              navigateTo: element.pageToLoad,
              id: element.id,
            });
            break;
          } else {
            let page = element.pages[0];
            refreshList.push({
              pathName: page.displayText,
              navigateTo: page.pageToLoad,
              id: element.id,
            });
            setSelectedPage(page.id);
            break;
          }
        }
        const authState = store.getState();
        if (
          authState.auth.facultyDetails.facultyId > 0 &&
          parentMenuItemId === 2
        ) {
          navigate("/faculty/facultydetails", {
            state: {
              params: `facultyId=${authState.auth.facultyDetails.facultyId}&mainPage=0`,
            },
          });
          setSelectedPage(10);
        } else {
          refreshList.forEach((v: any) => {
            const pathName = v?.navigateTo?.split("?")[0];
            const pathNameIds = v?.navigateTo?.split("?")[1];
            navigate(pathName, {
              state: {params: pathNameIds},
            });
          });
        }
      } catch (error: any) {
        loggedMessage(error, "", PageNames.MASTER_LAYOUT);
      }
    } else {
      if (urlParams?.length === 0) {
        for (let index = 0; index < subPages.length; index++) {
          const element = subPages[index];

          if (!element.pageToLoad) {
            for (let index = 0; index < element?.pages?.length; index++) {
              const page = element?.pages[index];
              if (page?.pageToLoad?.includes(urlPathname[2])) {
                setSelectedPage(page.id);
                break;
              }
            }
          }
        }
      }
    }
  }, []);

  React.useEffect(() => {
    getParentIndex();
    let pathNameLocation = window.location;

    firstLoop: for (let index = 0; index < subPages.length; index++) {
      const element = subPages[index];
      let found = false;
      secondLoop: for (let index = 0; index < element?.pages?.length; index++) {
        const page = element?.pages[index];
        if (
          pathNameLocation.pathname.includes("facultyrequestprofile") &&
          page.pageToLoad?.includes("facultytypeselection")
        ) {
          found = true;
          setSelectedPage(page.id);
          break secondLoop;
        } else if (
          pathNameLocation.pathname.includes("Addmultiplefaculty") &&
          page.pageToLoad?.includes("facultytypeselection")
        ) {
          found = true;
          setSelectedPage(page.id);
          break secondLoop;
        } else if (submenuid === page.id) {
          found = true;
          setSelectedPage(page.id);
          break secondLoop;
        }
      }
      if (found) {
        break firstLoop;
      }
    }
  }, [subPages]);

  React.useEffect(() => {
    let pathName = location.pathname;
    firstLoop: for (let index = 0; index < subPages.length; index++) {
      const element = subPages[index];
      let found = false;

      secondLoop: for (let index = 0; index < element?.pages?.length; index++) {
        const page = element?.pages[index];
        const pathNameUrl: any = page.pageToLoad?.split("?")[0];
        if ("/" + pathNameUrl === pathName && submenuid === page.id) {
          setSelectedPage(page.id);
          found = true;
          break secondLoop;
        }
      }
      if (found) {
        break firstLoop;
      }
    }
  }, [location.pathname, subPages]);

  const handleToggle = () => {
    setToggled(!toggled);
    setCollapsed(!collapsed);
  };

  function renderIcon(id: number) {
    const Menu = id;
    switch (Menu) {
      case 1:
        return <AssignmentIndIcon />;
      case 2:
        return <PersonSearchIcon />;
      case 3:
        return <RecentActorsIcon />;
      case 9:
        return <PersonAddAltIcon />;
      case 10:
      case 21:
        return <PersonOutlineIcon />;
      case 11:
        return <ChecklistIcon />;
      case 19:
        return <EventNoteOutlinedIcon />;
      case 20:
        return (
          <Box sx={{display: "flex", alignItems: "center"}} component="span">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.42 20">
              <g
                id="Group_591"
                data-name="Group 591"
                transform="translate(-37 -394)">
                <path
                  id="event_FILL0_wght400_GRAD0_opsz24"
                  d="M121.936-860a1.834,1.834,0,0,1-1.367-.588A1.958,1.958,0,0,1,120-862v-14a1.959,1.959,0,0,1,.569-1.413,1.834,1.834,0,0,1,1.367-.587h.968v-2h1.936v2h7.742v-2h1.936v2h.968a1.834,1.834,0,0,1,1.367.587A1.958,1.958,0,0,1,137.42-876v14a1.958,1.958,0,0,1-.569,1.413,1.834,1.834,0,0,1-1.367.588Zm0-2h13.549v-10H121.936Zm0-12h13.549v-2H121.936Zm0,0v0Z"
                  transform="translate(-83 1274)"
                />
                <path
                  id="search_FILL0_wght400_GRAD0_opsz24"
                  d="M124.831-834.762,123-836.6a1.735,1.735,0,0,1-.5.276,1.775,1.775,0,0,1-.6.1,1.826,1.826,0,0,1-1.342-.549,1.826,1.826,0,0,1-.549-1.342,1.826,1.826,0,0,1,.549-1.342,1.826,1.826,0,0,1,1.342-.549,1.826,1.826,0,0,1,1.342.549,1.826,1.826,0,0,1,.549,1.342,1.774,1.774,0,0,1-.1.6,1.735,1.735,0,0,1-.276.5l1.833,1.833Zm-2.939-2.037a1.263,1.263,0,0,0,.928-.382,1.263,1.263,0,0,0,.382-.928,1.263,1.263,0,0,0-.382-.928,1.263,1.263,0,0,0-.928-.382,1.263,1.263,0,0,0-.928.382,1.263,1.263,0,0,0-.382.928,1.263,1.263,0,0,0,.382.928A1.263,1.263,0,0,0,121.892-836.8Z"
                  transform="translate(-76.909 1244)"
                  stroke="#000"
                  strokeWidth="1"
                />
              </g>
            </svg>
          </Box>
        );
      case 27:
        return <DescriptionOutlinedIcon />;
      case 2264:
        return <ScheduleIcon />;
      case 2050:
        return <ManageAccountsOutlinedIcon />;
      case 2153:
      case 2156:
        return <OtherHousesOutlinedIcon />;
      case 2246:
        return <ReceiptLongOutlinedIcon />;
      case 2258:
        // return <BarChartOutlinedIcon />;
        return (
          <Box
            sx={{display: "flex", alignItems: "center", padding: "0px 0 0 8px"}}
            component="span">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
              <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zm-312 8v64c0 13.3 10.7 24 24 24s24-10.7 24-24l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80-96V280c0 13.3 10.7 24 24 24s24-10.7 24-24V120c0-13.3-10.7-24-24-24s-24 10.7-24 24zm80 64v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
            </svg>
          </Box>
        );
      case 69:
        return <NotificationImportantOutlinedIcon />;
      case 2180:
        return <CalendarMonthRoundedIcon />;
      case 2226:
        return <MonetizationOnOutlinedIcon />;
      case 40:
        return <ConstructionOutlinedIcon />;
      case 2053:
        return <HomeRepairServiceOutlinedIcon />;
      case 2193:
        return <MedicalServicesOutlinedIcon />;
      case 2184:
        return <DnsOutlinedIcon />;
      case 88:
        return <ConstructionOutlinedIcon />;
      case 2217:
        return <FitScreenOutlinedIcon />;
      case 2118:
        return <AssignmentOutlinedIcon />;
      case 2183:
        return <DescriptionOutlinedIcon />;
      case 2182:
        return <BrandingWatermarkOutlinedIcon />;
      default:
        break;
    }
  }

  const onSelfClick = (url: string, page: pages) => {
    try {
      setSelectedPage(page.id);
      const pathName = url?.split("?")[0];
      const pathNameIds = url?.split("?")[1];
      if (page.id === CPSConstants.APPROVAL_ALERT_ID) {
        dispatch(updateFacultyId(0));
      }
      if (SelectedTopMenu === pathName && submenuid === page.id) {
        // navigate(0);
        // Double click logic commented.
      } else {
        if (page.id === BRANDS_SUBBRANDS_ID) {
          let path = pathNameIds
            ? pathNameIds + "submenuid=" + page.id
            : "submenuid=" + page.id;
          navigate(pathName, {
            state: {
              params: path,
            },
          });
        } else {
          navigate(pathName, {
            state: {params: pathNameIds ? pathNameIds : "submenuid=" + page.id},
          });
        }
      }
    } catch (error: any) {
      loggedMessage(error, "", PageNames.MASTER_LAYOUT);
    }
  };

  const navigateToPage = (menu: subPages) => {
    try {
      let pageToLoad = menu.pageToLoad
        ? menu.pageToLoad
        : menu?.pages[0].pageToLoad;
      if (menu.isNew) {
        if (menu?.id === 2258) {
          window.open(pageToLoad, "_blank");
        } else {
          if (menu?.pages?.length > 0) {
            setSelectedPage(menu.pages[0].id);
          } else {
            setSelectedPage(menu.id);
          }
          navigate("/" + pageToLoad, {
            state: {
              params: menu.pageToLoad
                ? "submenuid=" + menu.id
                : "submenuid=" + menu?.pages[0].id,
            },
          });

          if (menu?.id === 27) {
            const pathName = menu?.pageToLoad?.split("?")[0];
            if (SelectedTopMenu === pathName) {
              navigate(0);
            }
          }
        }
      } else {
        // TODO: Remove this condition when Activity Module is implmented.
        setLoader(true);
        const authState = store.getState();
        const userIdentity = encrypt(authState.auth?.userDetails?.userIdentity);
        const userId = encrypt(authState.auth?.userDetails?.userId?.toString());
        const profileId = encrypt(
          authState.auth?.userDetails?.profileId?.toString(),
        );
        const switchedUserId = encrypt(
          authState.auth?.userDetails?.switchedUserId?.toString(),
        );
        const switchedProfileId = encrypt(
          authState.auth?.userDetails?.switchedProfileId?.toString(),
        );
        const switchedUserName = encrypt(
          authState.auth?.userDetails?.switchedUserName?.toString(),
        );
        const token = authState.auth?.authDetails?.token;
        if (menu.id === 2050 || menu.id === 20 || menu.id === 2246) {
          pageToLoad =
            "Activity.aspx?ActivityPageToLoad=" +
            pageToLoad +
            "&" +
            "subMenuId=" +
            menu.id;
          if (menu.id === 2050) {
            pageToLoad += "&MenuName=" + menu?.pages[0].displayText;
          } else if (menu.id === 20) {
            pageToLoad += "&MenuName=" + menu?.displayText;
          }
          pageToLoad += "&";
        } else if (
          menu.id === 40 ||
          menu.id === 88 ||
          menu.id === 2118 ||
          menu.id === 2180 ||
          menu.id === 2217 ||
          menu.id === 2226
        ) {
          pageToLoad =
            "Administration.aspx?AdminPageToLoad=" +
            (menu.id === 2226
              ? pageToLoad.replace("administration", "finance")
              : pageToLoad) +
            ".aspx&" +
            "subMenuId=" +
            menu.id;
          if (menu.id !== 2217) {
            pageToLoad += "&MenuName=" + menu?.pages[0].displayText;
          }
          pageToLoad += "&";
        } else {
          pageToLoad += "?";
        }
        const oldLink = `${OLD_CPS_URL}${pageToLoad}userIdentity=${userIdentity}&userId=${userId}&profileId=${profileId}&switchedUserId=${switchedUserId}&switchedProfileId=${switchedProfileId}&switchedUserName=${switchedUserName}&token=${token}`;

        window.location.href = oldLink;
      }
    } catch (error: any) {
      loggedMessage(error, "", PageNames.MASTER_LAYOUT);
    }
  };
  //TODO: Remove this condition in Cleaning Phase is implemented.
  const getParentIndex = () => {
    let parentIndex = 0;
    let urlParams = window.location.search;
    let urlPathname = window?.location?.pathname?.split("/");
    let isFound = false;
    if (urlParams?.length === 0) {
      for (let pindex = 0; pindex < subPages.length; pindex++) {
        const element = subPages[pindex];

        if (element?.pages?.length > 0) {
          for (let index = 0; index < element?.pages?.length; index++) {
            const page = element?.pages[index];

            if (page.id === BRANDS_SUBBRANDS_ID) {
              let path: any = page?.pageToLoad?.split("/")[1]?.split("?");
              if (path?.includes(urlPathname[2])) {
                parentIndex = pindex;
                isFound = true;
                break;
              }
            } else {
              if (page?.pageToLoad?.split("/")?.includes(urlPathname[2])) {
                parentIndex = pindex;
                isFound = true;
                break;
              }
            }
          }
        } else {
          if (
            parentIndex == 0 &&
            element?.pages?.length == 0 &&
            element?.pageToLoad !== null
          ) {
            if (element?.pageToLoad?.split("/")?.includes(urlPathname[2])) {
              parentIndex = pindex;
              isFound = true;
              break;
            }
          }
        }

        if (isFound) {
          break;
        }
      }
    }
    setMenuIndex(parentIndex);
    return parentIndex;
  };

  return (
    <Box
      component={"div"}
      className="sidenav-main-container"
      key="MainNavBarDiv">
      <Loader open={loader} />
      <Box
        component={"div"}
        style={sideBarNavStyles.sidenavBorderColor}
        key="MainNavlogo">
        <Box component={"div"} className="hamburger-menu" key="hanburger">
          <IconButton
            onClick={() => {
              handleToggle();
            }}
            size="medium">
            {toggled ? (
              <MenuOutlinedIcon fontSize="medium" />
            ) : (
              <MenuOpenOutlinedIcon fontSize="medium" />
            )}
          </IconButton>
        </Box>
        <Sidebar
          collapsed={collapsed}
          toggled={toggled}
          collapsedWidth="44px"
          backgroundColor="#FFFFFF"
          transitionDuration={500}
          width="215px">
          <Menu
            transitionDuration={500}
            rootStyles={{
              [`.${menuClasses.icon}`]: {
                color: "black",
              },
              [`.${menuClasses.menuItemRoot}`]: {
                fontWeight: "400",
                fontSize: CPSConstants.FONTREMTEXT,
              },
              [`.${menuClasses.subMenuRoot}`]: {
                fontWeight: "bold",
                fontSize: CPSConstants.FONTREMTEXT,
              },
            }}>
            {subPages.map((menu: subPages, index: number) => {
              const isOpen = index === menuIndex;
              return (
                <SubMenu
                  key={menu.id}
                  defaultOpen={isOpen}
                  open={isOpen}
                  label={menu?.displayText}
                  icon={renderIcon(menu.id)}
                  style={
                    menu?.pages.length > 0
                      ? sideBarNavStyles.Menu
                      : sideBarNavStyles.MenuNoChild
                  }
                  onClick={() => {
                    setMenuIndex(index);
                    navigateToPage(menu);
                  }}>
                  {menu?.id === 10 || menu?.id === 21 ? (
                    <FacultyBasicSearch />
                  ) : (
                    ""
                  )}
                  {menu?.pages?.map((page: pages, index: number) => {
                    return menu?.id !== 19 &&
                      menu?.id !== 2050 &&
                      menu?.id !== 40 &&
                      menu?.id !== 88 &&
                      menu?.id !== 2118 &&
                      menu?.id !== 2217 &&
                      menu?.id !== 2226 &&
                      menu?.id !== 2180 ? ( // TODO: Remove this condition when Activity Module is implemented.
                      <>
                        <MenuItem
                          active={page.id === selectedPage}
                          key={page.id}
                          style={
                            page.id !== selectedPage
                              ? sideBarNavStyles.inActiveSubMenu
                              : sideBarNavStyles.activeSubMenu
                          }
                          suffix={
                            <ArrowForwardIosIcon style={{fontSize: "0.8rem"}} />
                          }
                          onClick={() => {
                            onSelfClick(page.pageToLoad, page);
                          }}>
                          <span className="white-space">
                            {page?.displayText}
                          </span>
                        </MenuItem>
                      </>
                    ) : (
                      <></>
                    );
                  })}
                </SubMenu>
              );
            })}
          </Menu>
        </Sidebar>
      </Box>
    </Box>
  );
};

export default SidebarNav;
